import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { RequestForQuoteStatusEnum } from "@enums/requestForQuoteStatus.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { RequestForQuote } from "@interfaces/models/requestForQuote.interface";
import { SalesOrder } from "@interfaces/salesOrder.interface";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { RequestForQuoteService } from "@services/requestForQuote.service";
import { SalesOrderService } from "@services/salesOrder.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "salesOrders-id-rfqs",
	styleUrls: ["salesOrders-id-rfqs.css"],
	templateUrl: "salesOrders-id-rfqs.html"
})
export class SalesOrdersIdRFQsAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [
		{ method: "viewSalesOrder", text: "Go to Sales Order" }
	];
	headerSecondaryButtons: AdminHeaderButton[] = [
		{ icon: "fal fa-mailbox", method: "sendEmails", text: "Send All" }
	];
	itemId = 0;
	items: RequestForQuote[] = [];
	purchaseTypes: any;
	salesOrder: SalesOrder = new SalesOrder();
	statuses: any;
	title = "";

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService, private requestForQuoteService: RequestForQuoteService, private salesOrderService: SalesOrderService) {
		this.route.params.subscribe((params) => {
			this.itemId = params.id;
			this.getItems(params.id);
			this.getSalesOrder();
			this.title = `RFQs for Sales Order #${params.id}`;
		});

		this.deleteRow = this.deleteRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.checkGridExportPermissions();
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.statuses = GetPropertiesFromEnum(RequestForQuoteStatusEnum);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("RFQs for Sales Order")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this RFQ?");
		if (result) {
			this.requestForQuoteService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success("RFQ deleted!");
						this.getItems(this.itemId);
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`admin/requestForQuotes/${e.row.data.lookupId}_edit`]);
	}

	getItems(id: number) {
		this.requestForQuoteService.getForSalesOrder(id)
			.subscribe(
				(res: any) => this.items = res.response,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getSalesOrder() {
		this.salesOrderService.getSingleById(this.itemId)
			.subscribe(
				(res: any) => this.salesOrder = res.response,
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isEditButtonVisible(e: any) {
		return e.row.data.status === RequestForQuoteStatusEnum.Pending;
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "RFQs for Sales Order " + this.itemId;
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	sendEmails() {
		if (confirm("Are you sure you wish to send all these RFQs (excluding Won or Lost RFQs)? Please ensure the supplier RFQ contacts and the details on each RFQ are correct. You will not be able to edit the RFQs after sending them.") == false) {
			return;
		}

		this.requestForQuoteService.sendRFQsForSalesOrder(this.itemId)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					this.getItems(this.itemId);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	viewRow(e: any) {
		this.router.navigate([`admin/requestForQuotes/${e.row.data.lookupId}`]);
	}

	viewSalesOrder() {		
		this.router.navigate([`admin/salesOrders/${this.salesOrder.lookupId}`]);
	}
}